import { handleHideModal } from 'components/global/_helpers/global.helpers';
import SimpleModal from 'components/global/SimpleModal';
import UniversalInput from 'components/global/UniversalInput';
import { handleSubmitEditPipelineItem } from 'components/views/FounderDeal/_helpers/founderDeal.events';
import { PIPELINE_STATUS_OPTIONS } from 'constants/globalConstants';
import { $form, $view } from 'signals/global.signals';

const FounderDealEditPipelineModal = () => (
  <SimpleModal
    show={$view.value.activeModal === 'founder-deal-edit-pipeline'}
    onHide={handleHideModal}
    centered
    title={`Edit ${$form.value?.investorName} in ${$form.value?.dealName}`}
    onPrimaryClick={handleSubmitEditPipelineItem}
    primaryButtonText="Save"
    secondaryButtonText="Cancel"
    onSecondaryClick={handleHideModal}
    isLoading={$view.value.isModalLoading}
  >
    <UniversalInput
      type="select"
      name="pipelineStatus"
      label="Pipeline Status"
      options={PIPELINE_STATUS_OPTIONS}
      className="mb-16"
    />
    <UniversalInput
      type="money"
      name="amountInvested"
      label="Amount already invested in this deal"
      className="mb-16"
    />
    <UniversalInput
      type="money"
      name="previouslyCommitted"
      label="Amount committed to this deal"
      className="mb-16"
    />
  </SimpleModal>
);

export default FounderDealEditPipelineModal;
